import React from 'react'
import { Label } from '@/components/ui/label'
import ManagerFilter from '../../manager_filter'
import store from '../../../state/store'

class EditCoordinator extends React.Component {

  onChange = (value) => {
    store.emit('enquiry:update_coordinator', this.props.enquiry.id, value === '' ? null : value)
  }

  render() {
    const enquiry = this.props.enquiry

    return (
      <div className="flex items-center justify-end gap-2">
        <Label className="shrink-0">SDR:</Label>
        <div className="w-56">
          <ManagerFilter
            managers={enquiry.coordinator_options}
            selected={enquiry.coordinator}
            placeholder="Unassigned"
            can_unset={false}
            onChange={this.onChange}
          />
        </div>
      </div>
    )
  }
}

export default EditCoordinator
